export default "__VITE_ASSET__J7ziiJ25__"